import script from "./CalendarComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarComponent.vue?vue&type=script&setup=true&lang=js"

import "./CalendarComponent.vue?vue&type=style&index=0&id=2f489295&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f489295"]])

export default __exports__